'use client'
const CLIENT_SESSION_KEYS = 'dynamic_client_session_keys';
const CLIENT_SESSION_KEYS_STORAGE_OPTIONS = {
    priority: ['secureStorage', 'sessionStorage'],
};

export { CLIENT_SESSION_KEYS, CLIENT_SESSION_KEYS_STORAGE_OPTIONS };
